// ABOUTME: SPEC-67 D-1 — one id per page load, sent on every agent WebSocket connect of that page.
// ABOUTME: Only the page knows it is the same document; the backend cannot tell a blink from a refresh.
//
// WHY module scope: a module is evaluated once per document, so the id survives every SPEC-11
// reconnect and every App re-render, and a refresh (a new document) mints a new one — the owner's
// rule (2026-09-25): a refresh is a fresh visit on the film; a dropped connection is not.
let pageId = null;

/** RFC 4122 v4 from getRandomValues — the path for browsers without `crypto.randomUUID`. */
function uuidFromRandomValues() {
  const bytes = new Uint8Array(16);
  const c = typeof crypto !== 'undefined' ? crypto : null;
  if (c && typeof c.getRandomValues === 'function') c.getRandomValues(bytes);
  else for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function mint() {
  const c = typeof crypto !== 'undefined' ? crypto : null;
  return c && typeof c.randomUUID === 'function' ? c.randomUUID() : uuidFromRandomValues();
}

/** This page load's id. Minted on first call, then stable for the life of the document. Never throws. */
export function getPageId() {
  if (!pageId) pageId = mint();
  return pageId;
}
